import { render, staticRenderFns } from "./WebsiteAbout.vue?vue&type=template&id=7aa5b928&scoped=true"
import script from "./WebsiteAbout.vue?vue&type=script&lang=js"
export * from "./WebsiteAbout.vue?vue&type=script&lang=js"
import style0 from "./WebsiteAbout.vue?vue&type=style&index=0&id=7aa5b928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa5b928",
  null
  
)

export default component.exports